/**
 * Data the workspace shell needs before it can decide what to render.
 *
 * The Next.js `(users)` layout fetched these server-side and hydrated them into
 * React Query. The workspace route loader now awaits the same two requests, so
 * the shell still renders the correct plan and the correct gate state on first
 * paint rather than flashing a wrong one.
 */

import { apiFetch, apiUrl } from "@/core/lib/api";
import type { CompanyData } from "@/core/schema/profile-schema";

/**
 * The active workspace's company, or `null` when the backend is unreachable.
 *
 * The `null` is load-bearing: the setup gate treats it as "can't tell" and
 * stays down, rather than locking a user out of a workspace they would then
 * have no way to repair.
 */
export const companyQuery = {
  queryKey: ["company"] as const,
  queryFn: async (): Promise<CompanyData | null> => {
    try {
      const res = await apiFetch(apiUrl("/api/company"), {
        method: "GET",
        cache: "no-store",
      });
      if (!res.ok) return null;
      return (await res.json()) as CompanyData;
    } catch (err) {
      console.error("[company] backend unreachable", err);
      return null;
    }
  },
};
